/**
 * ProviderProfile — siempre renderiza V2 (rediseño).
 *
 * V1 (ProviderProfileV1) se mantiene en el repo por si hay que volver,
 * pero ya no se muestra ni hay toggle para alternar.
 */

import { lazy, Suspense } from "react"
import Spinner from "../Spinner/Spinner"

const ProviderProfileV2 = lazy(() => import("./ProviderProfileV2"))

const ProviderProfile = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ProviderProfileV2 />
        </Suspense>
    )
}

export default ProviderProfile
